const elementHeight = element => element?.getBoundingClientRect().height ?? 0;

export const adminNavigationElement = () => document.querySelector("[data-admin-navigation]");

export const adminNavigationHeight = () => elementHeight(adminNavigationElement());

export const emailVisibleContentOffset = () => {
  const stickyHeader = document.querySelector("[data-email-sticky-header]");

  return adminNavigationHeight() + elementHeight(stickyHeader);
};
